module.exports = __webpack_public_path__ + "img/05.c940acd8.jpg";